import {type ContactUsOrderFragment} from '@/graphql/types';

const formatOrderLabel = (order: ContactUsOrderFragment): string => {
  if (order.formattedOrderNumber === '#' && order.caterer?.name)
    return `New Order, ${order.caterer.name}`;
  if (order.formattedOrderNumber === '#') return 'New Order';

  const labelFragments = [order.formattedOrderNumber];

  const locationOrCatererFragment = order.event?.address?.nameOrLocation ?? order.caterer?.name;
  if (locationOrCatererFragment) labelFragments.push(locationOrCatererFragment);

  return labelFragments.join(', ');
};

export default formatOrderLabel;
